import { AxiosError } from 'axios';
import { getAxiosInstance } from '../axiosInstances/axios';
import { getRefreshToken, setToken } from './cookieHandler';

export const refreshExistingToken = async () => {
  const refresh = getRefreshToken();

  if (!refresh) {
    return {
      is_success: false,
      message: 'Token Removed!',
      data: null,
    };
  }

  try {
    const response = await getAxiosInstance('user').post<{
      is_success: boolean;
      message: string;
      status?: number;
      data: { refresh_token: string; access_token: string };
    }>(
      '/refresh/token/',
      {},
      {
        headers: {
          'Refresh-Token': refresh,
        },
      }
    );

    setToken(response.data.data.refresh_token, response.data.data.access_token);

    return response.data;
  } catch (error) {
    console.log('REFRESH ERROR: ', error);
    const err = error as AxiosError<{
      is_success: boolean;
      message: string;
      data: null;
    }>;

    if (err.response) {
      return {
        is_success: err.response.data.is_success,
        message: err.response.data.message,
        data: null,
      };
    }

    return {
      is_success: false,
      message: 'Something Went Wrong!',
      data: null,
    };
  }
};
